$('#socialicons a:nth-of-type(1)')
  .contents()
  .filter(function() {
    return this.nodeType === 3; // 텍스트 노드만
  })
  .first()
  .replaceWith('Googleでログイン');

  $('#socialicons a:nth-of-type(2)')
  .contents()
  .filter(function() {
    return this.nodeType === 3; // 텍스트 노드만
  })
  .first()
  .replaceWith('LINEでログイン');